/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CREATE_SESSION: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.createCheckoutSession',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CREATE_SESSION' },
      },
    },
    CREATE_SESSION: {
      invoke: {
        id: 'createCheckoutSession',
        src: 'createCheckoutSession',
        onDone: {
          target: 'CREATE_SESSION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_SESSION_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_SESSION_SUCCESS: {
      on: {
        TRIGGER_REFRESH: { target: 'CREATE_SESSION' },
      },
    },
    CREATE_SESSION_FAILED: {
      on: {
        START: { target: 'CREATE_SESSION' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
